import {DateRange} from '../stores/TimeIntervalStore';
import axios, {AxiosResponse} from 'axios';
import {handleError, handleErrorArray} from './errorHandling';
import {AbtestCompareRequest, ChannelDataRegister} from '../types/api/tableData/TableDataForChannel';
import {serializeParam} from './SearchtermAPI';
import {StickyRowSumsAbtestCompareRequest} from '../types/api/tableData/SumRowData';
import {extractMap} from './TableAPI';

export interface AbTestsWithVariants {
    testId: string;
    name?: string;
    variantIds: string[];
}

export function abTestsAndVariantsPerChannel(data: {channel: string; interval: DateRange}): Promise<AxiosResponse<AbTestsWithVariants[]>> {
    const {channel, ...params} = data;
    return axios.get(`abtest/${channel}`, {params}).catch(handleError('error:loadingChannelAbtestVariantsFailed'));
}

export function importAbTest(channel: string, testId: string, interval: DateRange): Promise<AxiosResponse<AbTestsWithVariants>> {
    return axios.post(`abtest/${channel}/import/${testId}`, {interval}).catch(handleError('error:importingAbTestsFailed'));
}

export function tableDataForAbtestComparison(data: AbtestCompareRequest): Promise<ChannelDataRegister[]> {
    const {mode, ...queryParams} = data;
    const method = mode === 'searchterm' ? `getABTestDifferencesTableDataForSearchTerms` : `getABTestDifferencesTableDataForProducts`;
    return axios
        .get(`tableData/${method}`, {params: queryParams, paramsSerializer: (params) => serializeParam(params)})
        .then(extractMap)
        .catch(handleErrorArray('error:loadingABTableDataFailed'));
}

export function stickyRowSumsForAbtestComparison(data: StickyRowSumsAbtestCompareRequest): Promise<ChannelDataRegister[]> {
    const {mode, ...queryParams} = data;
    return axios
        .get(`tableData/getABTestDifferencesStickyTableHeaderRowData/${mode}`, {
            params: queryParams,
            paramsSerializer: (params) => serializeParam(params),
        })
        .then(extractMap)
        .catch(handleErrorArray('error:loadingOfABChannelSumsFailed'));
}

export function getLastImportedDay({channel, testId}: {channel: string; testId: string}): Promise<AxiosResponse<number>> {
    return axios.get(`abtest/${channel}/lastImport/${testId}`).catch(handleError('error:loadingOfLastImportedDayForAbTestFailed'));
}

export function getLastAvailableAbtestEventTimestamp({channel, testId}: {channel: string; testId: string}): Promise<AxiosResponse<number>> {
    return axios.get(`abtest/${channel}/lastEvent/${testId}`).catch(handleError('error:loadingOfLastAvailableAbTestEventTimestampFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/AbTestAPI.ts